import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=a175dc4a"
var script = {}
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=a175dc4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports